var _defs, _path, _rect, _rect2, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzureDataLakeStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a16",
    x1: 9.24,
    y1: 0.96,
    x2: 8.85,
    y2: 16.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32d4f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#31d0f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#2cc3e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#25afd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#1c92ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198ab3"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 3.6H9.69a.34.34 0 01-.22-.07L7.35 2.12a.43.43 0 00-.22-.06H.9a.4.4 0 00-.4.39v13.1a.4.4 0 00.4.39h16.2a.4.4 0 00.4-.39V4a.4.4 0 00-.4-.4z",
    fill: "#005ba1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.05,
    y: 2.82,
    width: 3.86,
    height: 0.77,
    rx: 0.16,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.05,
    y: 2.82,
    width: 0.77,
    height: 0.77,
    rx: 0.11,
    fill: "#1ac3f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 3.58H9a.36.36 0 00-.28.12L7.37 5a.43.43 0 01-.28.11H.9a.4.4 0 00-.4.4v10a.4.4 0 00.4.39h16.2a.4.4 0 00.4-.39V4a.4.4 0 00-.4-.42z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.18 5.7a.15.15 0 00-.08 0s-.09 0-.13.07l-3.16 4.59a.16.16 0 000 .16.19.19 0 00.15.1h1.87L8 13.4a.13.13 0 00.07.18.1.1 0 00.07 0c.06 0 .09 0 .13-.07l3.26-4.66v-.1a.17.17 0 00-.17-.16h-2l.81-2.73a.13.13 0 00.01-.16z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureDataLakeStore);
export default __webpack_public_path__ + "static/media/azure-dataLakeStore.b366e5ef07730fe8c02df1bf0744754e.svg";
export { ForwardRef as ReactComponent };